module.exports = __webpack_public_path__ + "img/xd.c7bdf51f.png";